// FUNCTIONS
const renderSliderInitial = () => {
	main.sync(thumbnails);

	main.mount();
	thumbnails.mount();

	main.on('move', function (newIndex, prevIndex, destIndex) {
		const index = String(newIndex + 1).padStart(2, '0');

		const copy = document.getElementById('splide02-slide' + index).dataset.copy;
		const heading = document.getElementById('splide02-slide' + index).dataset.heading;
		const link = document.getElementById('splide02-slide' + index).dataset.link;

		document.querySelector('.shows-slider-information .copy').innerHTML = copy;
		document.querySelector('.shows-slider-information .link a').href = link;
		document.querySelector('.shows-slider-information h4').textContent = heading;
	});
};

// VARIABLES
const main = new Splide('.shows-slider-main', {
	arrows: false,
	fixedHeight: '50rem',
	mediaQuery: 'max',
	pagination: false,
	rewind: true,
	type: 'fade',

	breakpoints: {
		767: {
			fixedHeight: '25rem'
		}
	}
});

const thumbnails = new Splide('.shows-slider-thumbnails', {
	arrows: false,
	fixedHeight: 60,
	fixedWidth: 100,
	focus: 'center',
	gap: 10,
	isNavigation: true,
	mediaQuery: 'max',
	pagination: false,
	rewind: true,

	breakpoints: {
		767: {
			fixedHeight: 44,
			fixedWidth: 60
		}
	}
});

// EVENT LISTENERS
document.addEventListener('DOMContentLoaded', () => {
	renderSliderInitial();
});